import { PageItem } from "~/features/chat/hooks/useDocList";

const SECTION_TITLE_HEIGHT = 21;

export const calculateItemHeight = (
  page: PageItem,
  itemWidth: number,
  paddingBottom: number
): number => {
  const isActualDimensions = page.rotate % 180 === 0;

  const imageWidth = isActualDimensions ? page.width : page.height;
  const imageHeight = isActualDimensions ? page.height : page.width;

  const scale = itemWidth / imageWidth;

  const pageHeight = imageHeight * scale;

  let itemHeight = pageHeight + paddingBottom;

  // Add section title height if item opens a section
  if (page.opensSection) {
    itemHeight += SECTION_TITLE_HEIGHT;
  }

  return itemHeight;
};
